<div mat-dialog-content>
  <mat-form-field>
    <input matInput [(ngModel)]="category" placeholder="Enter Category Name">
  </mat-form-field>
</div>
<div class="action-panel text-right">
  <button mat-raised-button class="btn btn-primary m-left" type="submit" (click)="onSubmit()"
    color="primary">Save</button>
  <button mat-raised-button class="btn m-left btn-light" color="warn" (click)="onNoClick()">Cancel</button>
</div>